import { Can } from 'providers/casl'
import { onFinanceAccess } from '../features/finance'
import { onLayoutAccess } from '../features/layout'
import { onPerformanceAccess } from '../features/performance'
import { onPortalAccess } from '../features/portal'
import { onProductAccess } from '../features/product'
import { onTagAccess } from '../features/tag'

export const onFinancialViewer = (can: Can) => {
  onFinanceAccess(can)
  onLayoutAccess(can)
  onPortalAccess(can)
  onProductAccess(can)
  onTagAccess(can)
  onPerformanceAccess(can)
}
